import { Component, h, Host, Element } from '@stencil/core';


@Component({
    tag: 'lilu-hero',
    styleUrl: 'lilu-hero.scss',
    shadow: true
})
export class LiluHero {

    private class = '';

    @Element()
    readonly el: HTMLElement;

    componentWillLoad() {
      const img = this.el.querySelector('lilu-img');
      if (!img) {
        this.class = 'no-img'
      } else {
        if (!img.getAttribute('slot')) {
          img.setAttribute('slot', 'background');
        }
      }
    }

    render() {
        return (
          <Host class={this.class}>
            <div class={`hero ${this.class}`}>
              <div class='background-slot'>
                <slot name='background'></slot>
              </div>
              <div class='content'>
                <slot></slot>
              </div>
            </div>
          </Host>
        );
    }
}
